module.exports = __webpack_public_path__ + "images/13700712cda79cdda220188f2273f4c5-living_books.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/living_books.jpg
// module id = ./src/assets/images/content/living_books.jpg
// module chunks = 0